import React from "react";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";
import DatacenterList from "../common/DatacenterList/DatacenterList";
import ConfigureWidgetData from "../common/Widgets/configureWidget";
import DatePicker from "../common/DatePicker/DatePicker";
import moment from "moment";
import {
  apiPost,
  apiBatchRequest,
  apiRequest,
  apiBatchRequestWithCache
} from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import RenderLayout from "./RenderLayout";
import SettingsApplicationsOutlined from "@material-ui/icons/QueueOutlined";
import RestoreOutlined from "@material-ui/icons/RestoreOutlined";
import SlidingPanel from "react-sliding-side-panel";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import commonLabels from "../../constants/messageConstants";
import { ShowToast, toastType } from "../../utils/toast-service";

import InlineFormIcon from "@material-ui/icons/LinearScaleOutlined";
import KeyValueIcon from "@material-ui/icons/ViewList";
import TableIcon from "@material-ui/icons/TableChart";
import DonutIcon from "@material-ui/icons/DonutSmall";
import PieIcon from "@material-ui/icons/PieChart";
import BarChartIcon from "@material-ui/icons/BarChartOutlined";
import TimelineIcon from "@material-ui/icons/Timeline";
import MapIcon from "@material-ui/icons/Map";
import Fab from "@material-ui/core/Fab";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";
import { Responsive, WidthProvider } from "react-grid-layout";
import camelcaseKeys from "camelcase-keys";
import { IsSectionVisible } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
import { isDesktop, isMobile, isTablet } from "react-device-detect";
import "./DatacenterUser/DatacenterUser.less"
import _ from "lodash";
import { getUserData } from "../../store/user/actions";
const ResponsiveGridLayout = WidthProvider(Responsive);
const WidgetContainer = "WC";
export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      widgetconfig: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyId"),
      startDate: new moment()
        .subtract(1, "months")
        .startOf("month")
        .format("MM/DD/YYYY"),
      endDate: new moment()
        .subtract(1, "months")
        .endOf("month")
        .format("MM/DD/YYYY"),
      layout: [],
      openAddWidgetPanel: false,
      openConfigureWidgetPanel: false,
      isOpenConfirmationPanel: false,
      widgetMasterList: undefined,
      sampleData: undefined,
      layoutUpdated: false,
      ComparisonData: [],
    };
  }

  componentWillMount() {}

  /**
   * Will be called on startup
   */
  componentDidMount() {
    const state= this.state;
    if (state.datacenterList == undefined) {
      this.getDataCenterList();
    }
  }

  /**
   * Get data center list
   */
  getDataCenterList = () => {
    apiBatchRequestWithCache([
      {
        url: API_URL.datacenter.getDatacenterList,
        param: {},
        key: "datacenterList",
        fromCache:true,
        duration:15
      },
      {
        url: API_URL.user.GetUserConfigurationDetails,
        param: {},
        key: "userConfigurationDetails",
        // fromCache:true,
        // duration:15
      }
    ]).then(({ datacenterList, userConfigurationDetails }) => {
      // this is settings for the reports

      if (localStorage.getItem("selectedPropertyId") == undefined) {
        localStorage.setItem(
          "selectedPropertyId",
          datacenterList.data[0].propertyID
        );
      }

      if (localStorage.getItem("selectedPropertyIdMultiple") == undefined) {
        localStorage.setItem("selectedPropertyIdMultiple", [
          datacenterList.data[0].propertyID
        ]);
      }

      if (
        localStorage.getItem("selectedPropertyIdMultipleNames") == undefined
      ) {
        localStorage.setItem("selectedPropertyIdMultipleNames", [
          datacenterList.data[0].name
        ]);
      }

      if (localStorage.getItem("Abbreviation") == undefined) {
        localStorage.setItem("Abbreviation", [
          datacenterList.data[0].abbreviation
        ]);
      }

      if (localStorage.getItem("MTDDefault") == undefined) {
        localStorage.setItem("MTDDefault", [moment().format("MM")]);
      }

      const layout = this.GetLayout(
        camelcaseKeys(
          (userConfigurationDetails.data || {}).widgetConfiguration || []
        )
      );

      localStorage.setItem(
        "userConfiguration",
        JSON.stringify((userConfigurationDetails.data || {}).groups || [])
      );
      //console.log((userConfigurationDetails.data || {}).groups[0].groupName);
      if (userConfigurationDetails.data.groups[0].groupName == "DC_Tenant") {
        //console.log(userConfigurationDetails.data.userInfo.propertyId);
        localStorage.setItem(
          "selectedPropertyId",
          userConfigurationDetails.data.userInfo.propertyId
        );
      }
      const{layoutUpdated}= this.state;
      this.setState({
        datacenterList: datacenterList.data,
        widgetconfig: camelcaseKeys(
          (userConfigurationDetails.data || {}).widgetConfiguration || []
        ),
        layout: layout,
        openAddWidgetPanel: false,
        openConfigureWidgetPanel: false,
        layoutUpdated: !layoutUpdated,
        selectedPropertyId:
          localStorage.getItem("selectedPropertyId") != undefined
            ? localStorage.getItem("selectedPropertyId")
            : (datacenterList.data[0] || {}).propertyID
        // this.state.selectedPropertyId == 0
        //   ? (datacenterList.data[0] || {}).propertyID || 0
        //   : this.state.selectedPropertyId,
      });
    });
  };

  /**
   * Return layout configurations as per the parameters provided
   * @param {*} widgetconfig 
   * @returns Layout
   */
  GetLayout = widgetconfig => {
    let layouts = localStorage.getItem("layout") || "";
    if (layouts != "") {
      layouts = JSON.parse(layouts);
    } else {
      layouts = [];
    }
    const newLayout = [];

    widgetconfig.forEach(config => {
      const key =
        WidgetContainer +
        "_" +
        config.usersWidgetMappingId +
        "_" +
        config.widgetId;
      let layout = layouts.find(x => x.i == key);
      if (layout == undefined) {
        layout = {};
      }

      layout.minW = config.minWidth;
      layout.minH = config.minHeight;
      layout.w = config.width;
      layout.h = config.height;
      layout.x = config.xPosition;
      layout.y = config.yPosition;
      layout.i = key;
      newLayout.push(layout);
    });
    newLayout.sort((a, b) => a.x - b.x);
    newLayout.sort((a, b) => a.y - b.y);
    localStorage.setItem("layout", JSON.stringify(newLayout));
    return newLayout;
  };

  /**
   * open confirmation panel window
   */
  OpenConfirmationPanel = () => {
    this.setState({ isOpenConfirmationPanel: true });
  };

  /**
   * close confirmation panel window
   */
  CloseConfirmationPanel = () => {
    this.setState({ isOpenConfirmationPanel: false });
  };

  /**
   * Reset values to the default
   * @param {*} res 
   */
  ResetToDefault = res => {
    if (res == true) {
      apiRequest({
        url: API_URL.widget.ResetUserWidgetsToDefault
      }).then(response => {
        response.success == false
          ? ShowToast(
              "Server Error: Unable to reset widgets.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Dashboard reset to default successful.",
              toastType.SUCCESS,
              5000,
              200
            );
            getUserData();
        this.setState({ isOpenConfirmationPanel: false }, () => {
          localStorage.removeItem("layout");
          this.getDataCenterList();
        });
      });
    } else {
      this.setState({ isOpenConfirmationPanel: false });
    }
  };

  /**
   * Call on property selection and set values
   * @param {*} id 
   */
  onPropertySelect = id => {
    this.setState({ selectedPropertyId: id });
    localStorage.setItem("selectedPropertyId", id);
    localStorage.setItem("selectedPropertyIdMultiple", id);
  };

  /**
   * call on date range selection
   */
  onDateRange = (startDate, endDate) => {
    this.setState({ startDate: startDate, endDate: endDate });
  };

  /**
   * call on layout change and set values
   */
  onLayoutChange(layout, layouts) {
    localStorage.setItem("layout", JSON.stringify(layout));
    console.log(layout, layouts);
  }

  /**
   * Open comparision details panel
   * @param {*} config 
   * @param {*} propertyId 
   */
  openComparisonDetailsPanel = (config, propertyId) => {
    const { ComparisonData } = this.state;
    ComparisonData.push({ propertyId: propertyId, WidgetConfig: config });
  };

  /**
   * Open widget panel window
   */
  OpenWidgetPanel = () => {
    const state= this.state;
    if (state.widgetMasterList === undefined) {
      apiBatchRequest([
        {
          url: API_URL.widget.GetWidgetMasterList,
          param: {},
          key: "widgetMasterList"
        }
      ]).then(({ widgetMasterList }) => {
        this.setState({
          openAddWidgetPanel: true,
          widgetMasterList: camelcaseKeys(widgetMasterList.data)
        });
      });
    } else {
      this.setState({
        openAddWidgetPanel: true
      });
    }
  };

  /**
   * Opens widget panels configuration window
   * @param {*} config 
   * @param {*} sampleData 
   */
  OpenWidgetConfigurationPanel = (config, sampleData) => {
    if (config != undefined) {
      const state= this.state;
      if (state.widgetMasterList === undefined) {
        apiBatchRequest([
          {
            url: API_URL.widget.GetWidgetMasterList,
            param: {},
            key: "widgetMasterList"
          }
        ]).then(({ widgetMasterList }) => {
          this.setState({
            openConfigureWidgetPanel: true,
            selectedWidgetConfig: camelcaseKeys(config),
            sampleData: camelcaseKeys(sampleData),
            widgetMasterList: camelcaseKeys(widgetMasterList.data)
          });
        });
      } else {
        this.setState({
          openConfigureWidgetPanel: true,
          selectedWidgetConfig: config,
          sampleData: sampleData
        });
      }
    }
  };

  /**
   * Remove widget mapping from the screen
   * @param {*} id 
   */
  RemoveWidgetMapping = id => {
    apiRequest({
      url: API_URL.widget.RemoveUserWidgetMapping + "?userWidgetMappingId=" + id
    }).then(response => {
      response.success == false
        ? ShowToast(
            "Server Error: Unable to remove Widget.",
            toastType.ERROR,
            5000,
            500
          )
        : ShowToast(
            "Widget deleted successfully.",
            toastType.SUCCESS,
            5000,
            200
          );
      this.getDataCenterList();
    });
  };

  /**
   * Add new Widget mapping on the screen
   * @param {*} id 
   */
  AddWidgetMapping = id => {
    apiRequest({
      url: API_URL.widget.AddWidgetMapping,
      params: { widgetId: id }
    }).then(response => {
      response.success == false
        ? ShowToast(
            "Server Error: Unable to add widget.",
            toastType.ERROR,
            5000,
            500
          )
        : ShowToast("Widget added successfully.", toastType.SUCCESS, 5000, 200);
      this.getDataCenterList();
    });
  };

  /**
   * Get layout from the local storage
   * @returns 
   */
  GetLayoutFromStorage = () => {
    let layouts = localStorage.getItem("layout") || "";
    if (layouts != "") {
      layouts = JSON.parse(layouts);
    } else {
      layouts = [];
    }
    return layouts;
  };

  /**
   * will be called on save configuration
   * @param {*} configuration 
   * @param {*} updateLayout 
   */
  onSaveConfiguration = (configuration, updateLayout = true) => {
    if (configuration.usersWidgetMappingId > 0 && updateLayout) {
      const layouts = this.GetLayoutFromStorage();
      let layoutConfig = undefined;
      layouts.map(obj => {
        if (
          obj.i ===
          WidgetContainer +
            configuration.usersWidgetMappingId +
            configuration.widgetId
        ) {
          layoutConfig = obj;
          return;
        }
      });

      if (layoutConfig != undefined) {
        configuration.width = layoutConfig.w || 3;
        configuration.height = layoutConfig.h || 3;
        configuration.xPosition = layoutConfig.x || 3;
        configuration.yPosition = layoutConfig.y || 3;
      }
    }
    apiPost({
      url: API_URL.widget.UpdateUserWidgetMapping,
      postBody: configuration
    }).then(({ success: isExecuted }) => {
      if (updateLayout) {
        if (isExecuted == true) {
          if (configuration.usersWidgetMappingId > 0) {
            ShowToast(
              commonLabels.widgetConfigurationUpdateSuccess.message,
              toastType.SUCCESS,
              5000,
              commonLabels.widgetConfigurationUpdateSuccess.code
            );
          } else {
            ShowToast(
              commonLabels.widgetConfigurationAddedSuccess.message,
              toastType.SUCCESS,
              5000,
              commonLabels.widgetConfigurationAddedSuccess.code
            );
          }
        } else if (configuration.usersWidgetMappingId > 0) {
          ShowToast(
            commonLabels.widgetConfigurationUpdateFail.message,
            toastType.ERROR,
            5000,
            commonLabels.widgetConfigurationUpdateFail.code
          );
        } else {
          ShowToast(
            commonLabels.widgetConfigurationAddFail.message,
            toastType.ERROR,
            5000,
            commonLabels.widgetConfigurationAddFail.code
          );
        }
      }
      this.getDataCenterList();
    });
  };

  /**
   * Item call Back
   * @param {*} layout 
   * @param {*} oldItem 
   * @param {*} newItem 
   * @param {*} placeholder 
   * @param {*} e 
   * @param {*} element 
   */
  ItemCallback = (layout, oldItem, newItem, placeholder, e, element) => {
    // console.log(layout, oldItem, newItem, placeholder, e, element);
    if (element != undefined && element.parentElement != undefined) {
      let configId = element.getAttribute("userswidgetmappingid");
      if (configId === null || configId === undefined)
        configId = element.parentElement.getAttribute("userswidgetmappingid");
      if (configId != undefined && configId != null) {
        const configuration = this.state.widgetconfig.find(
          x => x.usersWidgetMappingId.toString() === configId
        );
        if (
          configuration != undefined &&
          _.isEqual(oldItem, newItem) == false
        ) {
          configuration.width = newItem.w;
          configuration.height = newItem.h;
          configuration.xPosition = newItem.x;
          configuration.yPosition = newItem.y;
          this.onSaveConfiguration({ ...configuration }, false);
        }
      }
    }
  };

  /**
   * Returns chart icons as per requirments
   * @param {*} type 
   * @returns 
   */
  getChartIcon = type => {
    const size = "small";

    switch (type) {
      case 1:
        return <InlineFormIcon fontSize={size} />;
      case 2:
        return <KeyValueIcon fontSize={size} />;
      case 3:
        return <TableIcon fontSize={size} />;
      case 4:
        return <TimelineIcon fontSize={size} />;
      case 5:
      case 8:
      case 9:
        return <BarChartIcon fontSize={size} />;
      case 6:
        return <DonutIcon fontSize={size} />;
      case 7:
        return <PieIcon fontSize={size} />;
      case 10:
        return <MapIcon fontSize={size} />;
      default:
        return <TableIcon fontSize={"medium"} />;
    }
  };
  render() {
    const {
      selectedPropertyId,
      startDate,
      endDate,
      datacenterList,
      widgetconfig,
      openAddWidgetPanel,
      openConfigureWidgetPanel,
      widgetMasterList,
      selectedWidgetConfig,
      isOpenConfirmationPanel,
      sampleData,
      layout,
      layoutUpdated
    } = this.state;

    const addWidgetVisible = IsSectionVisible(
      SECTIONS.DASHBOARD,
      SECTIONS.ADD_WIDGET
    );
    const resetWidgetVisible = IsSectionVisible(
      SECTIONS.DASHBOARD,
      SECTIONS.RESET_TO_DEFAULT
    );
    //const IsEditable= permission.accessTypeId>1 ? true :false;    const ShowData= permission.showData

    return (
      <div className={"dcUser-wrapper"}>
        <div className={"dcUser-top-nav"}>
          {(isMobile||isTablet)?<></>:<div className={"dc-name-div"}>
            {/* <div className="dashboard-user-access">DASHBOARD</div> */}
                                      </div>}
          <div className={"dc-list-div"}>
            <DatacenterList
              dataSource={datacenterList}
              onPropertySelect={this.onPropertySelect}
              selectedPropertyId={selectedPropertyId}
              classTitle={"dc-list-select"}
            />
          </div>
          <div className={"dc-date-div"}>
            <Tooltip title={"Date Range"} aria-label={"Date Range"}>
              <DatePicker
                onDateChange={this.onDateRange}
                startDate={startDate}
                endDate={endDate}
              />
            </Tooltip>
            {/* <SettingsApplicationsOutlined ></SettingsApplicationsOutlined> */}
          </div>
        </div>
        {widgetconfig && (
          <>
            <ResponsiveGridLayout
              className={"layout"}
              layouts={{ lg: layout }}
              onLayoutChange={this.onLayoutChange}
              breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
              cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
              rowHeight={30}
              preventCollision={false}
              autoSize
              useCSSTransforms
              onDragStop={this.ItemCallback}
              onResizeStop={this.ItemCallback}
              //compactType="horizontal"
            >
              {widgetconfig &&
                widgetconfig.map((config) => {
                  const layoutConfig = layout.find(
                    x =>
                      x.i ==
                      WidgetContainer +
                        "_" +
                        config.usersWidgetMappingId +
                        "_" +
                        config.widgetId
                  );
                  (layoutConfig || {}).isDraggable = isDesktop;
                  return (
                    <div
                      id={
                        WidgetContainer +
                        "_" +
                        config.usersWidgetMappingId +
                        "_" +
                        config.widgetId
                      }
                      key={
                        WidgetContainer +
                        "_" +
                        config.usersWidgetMappingId +
                        "_" +
                        config.widgetId
                      }
                      data-grid={layoutConfig}
                      userswidgetmappingid={config.usersWidgetMappingId}
                    >
                      <RenderLayout
                        datacenterList={datacenterList}
                        propertyId={selectedPropertyId}
                        key={
                          "widget" +
                          config.usersWidgetMappingId +
                          config.widgetId
                        }
                        startDate={startDate}
                        endDate={endDate}
                        widgetconfig={camelcaseKeys({ ...config })}
                        OpenWidgetConfigurationPanel={
                          this.OpenWidgetConfigurationPanel
                        }
                        onRemoveWidgetMapping={this.RemoveWidgetMapping}
                        layoutUpdated={layoutUpdated}
                      />
                    </div>
                  );
                })}
              {/* {<div key="AddWidget" data-grid={{ x: Math.max.apply(Math, layout.map(function (o) { return o.x; })), y: Math.max.apply(Math, layout.map(function (o) { return o.y; })), w: 1, h: 3, isResizable: false }}> <div className="addWidget">
                                <button onClick={this.OpenWidgetPanel}>  <p>
                                    <SettingsApplicationsOutlined style={{ color: grey[500] }} ></SettingsApplicationsOutlined></p> <span style={{ color: grey[500] }}>Add widgets</span></button>  </div> </div>} */}
            </ResponsiveGridLayout>
            {addWidgetVisible && (
              <Tooltip title={"Add Widget"} aria-label={"add"}>
                <Fab
                  aria-label={"Add"}
                  className={"fabAddWidget"}
                  onClick={this.OpenWidgetPanel}
                >
                  <SettingsApplicationsOutlined
                    style={{ color: "#07406d" }}
                  />
                </Fab>
              </Tooltip>
            )}
            {resetWidgetVisible && (
              <Tooltip title={"Reset to Default"} aria-label={"add"}>
                <Fab
                  aria-label={"Reset"}
                  className={"fabResetWidget"}
                  onClick={() => {
                    this.OpenConfirmationPanel();
                  }}
                >
                  <RestoreOutlined
                    style={{ color: "#07406d" }}
                  />
                </Fab>
              </Tooltip>
            )}
          </>
        )}
        <SlidingPanel type={"right"} isOpen={openAddWidgetPanel} size={30}>
          <div className={"addwidget-container"}>
            <div className={"header row"}>
              {" "}
              <div className={"col-xs-11"}>{"Widget Configuration"}</div>
              <div className={"col-xs-1 center-xs"}>
                {" "}
                <Tooltip title={"Close"}>
                  <IconButton
                    aria-label={"CloseIconAddWidgetPanel"}
                    size={"small"}
                    onClick={() => this.setState({ openAddWidgetPanel: false })}
                  >
                    <CloseIcon fontSize={"small"} size={"small"} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <div className={"row widget-content"}>
              <div className={"widget-holder col-lg-11 end-lg"}>
                <div className={"row col-lg-12"}>
                  {resetWidgetVisible && (
                    <Button
                      size={"small"}
                      variant={"outlined"}
                      onClick={() => {
                        this.OpenConfirmationPanel();
                      }}
                      color={"primary"}
                    >
                      {"Reset to Default\r"}
                    </Button>
                  )}
                </div>
              </div>
              {widgetMasterList &&
                widgetMasterList.map((widget) => {
                  if (widget.isAccessible == true) {
                    let isDisabled = false;
                    if (
                      (widgetconfig || []).find(
                        x => x.widgetId === widget.widgetId
                      ) !== undefined
                    ) {
                      isDisabled = true;
                    }
                    return (
                      <div className={"widget-holder col-lg-11"}>
                        <div className={"row col-lg-12"}>
                          <div className={"widgetIcon col-lg-1"}>
                            {this.getChartIcon(widget.widgetType)}
                          </div>
                          <div className={"col-lg-8"}>
                            <h1>{widget.name}</h1>
                            <span className={"small-caption"}>
                              {"Type: "}{widget.widgetTypeName}
                            </span>
                            <p className={"small-caption"}>
                              {widget.description}
                            </p>
                          </div>
                        </div>
                        <div className={"col-lg-12 end-lg"}>
                          <Button
                            size={"small"}
                            variant={"outlined"}
                            disabled={isDisabled}
                            onClick={() => {
                              this.AddWidgetMapping(widget.widgetId);
                            }}
                            color={"primary"}
                          >
                            {"Add to dashboard\r"}
                          </Button>

                          {widget.isConfigurable && (
                            <Button
                              size={"small"}
                              variant={"outlined"}
                              onClick={() => {
                                this.OpenWidgetConfigurationPanel(
                                  { ...widget },
                                  {}
                                );
                                this.setState({
                                  openAddWidgetPanel: false,
                                  openConfigureWidgetPanel: true,
                                  selectedWidgetConfig: { ...widget }
                                });
                              }}
                              color={"primary"}
                            >
                              {"Configure & Add\r"}
                            </Button>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return "";
                  }
                })}
            </div>
          </div>
        </SlidingPanel>

        <SlidingPanel
          key={"configureWidgetPanel"}
          type={"right"}
          isOpen={openConfigureWidgetPanel}
          size={30}
        >
          {selectedWidgetConfig && (
            <div className={"addwidget-container"}>
              <div className={"header row"}>
                {" "}
                <div className={"col-xs-11"}>{"Configuration"}</div>
                <div className={"col-xs-1 center-xs"}>
                  <Tooltip title={"Close"}>
                    <IconButton
                      aria-label={"CloseIconconfigurationWidgetPanel"}
                      size={"small"}
                      onClick={() =>
                        this.setState({ openConfigureWidgetPanel: false })}
                    >
                      <CloseIcon fontSize={"small"} size={"small"} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              <div className={"row widget-content"}>
                <ConfigureWidgetData
                  masterConfig={camelcaseKeys(
                    widgetMasterList.find(
                      x => x.widgetId == selectedWidgetConfig.widgetId
                    )
                  )}
                  chartConfig={camelcaseKeys({ ...selectedWidgetConfig })}
                  sampleData={camelcaseKeys({ ...sampleData })}
                  onSaveConfiguration={this.onSaveConfiguration}
                />
              </div>
            </div>
          )}
        </SlidingPanel>

        <ConfirmDialog
          IsOpen={isOpenConfirmationPanel}
          Message={commonLabels.ResetToDefault.message}
          OnHandelClick={this.ResetToDefault}
        />
      </div>
    );
  }
}
